/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/prefer-default-export */
// import axios from 'axios';
import { apiClient, handleResponse } from './axios';

async function getCompanyById(companyId) {
  try {
    const response = await apiClient.get(`/company/${companyId}`);
    const user = await handleResponse(response);
    return user;
  } catch (err) {
    return console.error(err);
  }
}

async function getCodesByCompany(companyId) {
  try {
    const response = await apiClient.get(`/code/company/${companyId}`);
    const user = await handleResponse(response);
    return user;
  } catch (err) {
    return console.error(err);
  }
}

async function getCompanyByGroup(groupId) {
  try {
    const response = await apiClient.get(`/company/group/${groupId}`);
    const user = await handleResponse(response);
    return user;
  } catch (err) {
    return console.error(err);
  }
}

async function getCompanyExports(companyId) {
  try {
    const response = await apiClient.get(`/company/export/${companyId}`);
    const user = await handleResponse(response);
    return user;
  } catch (err) {
    return console.error(err);
  }
}

async function getCompanyDataById(companyId) {
  try {
    const response = await apiClient.get(`/companyData/${companyId}`);
    const user = await handleResponse(response);
    return user;
  } catch (err) {
    return console.error(err);
  }
}

async function updateExamConcerned(companyId) {
  try {
    const response = await apiClient.put(`/companyData/examConcerned/${companyId}`);
    const user = await handleResponse(response);
    return user;
  } catch (err) {
    return console.error(err);
  }
}

async function updateCompanyAdminData(companyId, body) {
  try {
    const response = await apiClient.put(`/companyData/admin/${companyId}`, body);
    const user = await handleResponse(response);
    return user;
  } catch (err) {
    return console.error(err);
  }
}

async function updateCompanyPedagogicData(companyId, body) {
  try {
    const response = await apiClient.put(`/companyData/pedagogic/${companyId}`, body);
    const user = await handleResponse(response);
    return user;
  } catch (err) {
    return console.error(err);
  }
}

async function updateCompanySemesters(companyId, body) {
  try {
    const response = await apiClient.put(`/companyData/semesters/${companyId}`, body);
    const user = await handleResponse(response);
    return user;
  } catch (err) {
    return console.error(err);
  }
}

async function updateCompanyCriterias(companyId, body) {
  try {
    const response = await apiClient.put(`/companyData/criterias/${companyId}`, body);
    const user = await handleResponse(response);
    return user;
  } catch (err) {
    return console.error(err);
  }
}

async function newCompany(company) {
  try {
    const url = '/company/';

    const response = await apiClient.post(url, company);
    const data = await handleResponse(response);
    return data;
  } catch (err) {
    return console.error(err);
  }
}

async function updateCompany(companyId, data) {
  try {
    const url = `/company/${companyId}`;

    const response = await apiClient.put(url, data);
    const company = await handleResponse(response);
    return company;
  } catch (err) {
    return console.error(err);
  }
}

async function updateCompanyDataPonderation(companyId, ponderation) {
  try {
    const url = `/companyData/${companyId}/${ponderation}`;

    const response = await apiClient.put(url);
    const company = await handleResponse(response);
    return company;
  } catch (err) {
    return console.error(err);
  }
}

async function rejectGroupProposal(companyId, data) {
  try {
    const body = {
      companyId,
      groupRejection: data,
    };
    const response = await apiClient.put('/company/grouprejection', body);
    const company = await handleResponse(response);
    return company;
  } catch (err) {
    return console.error(err);
  }
}

export const companyServices = {
  getCompanyById,
  newCompany,
  updateCompany,
  getCompanyExports,
  getCompanyDataById,
  getCodesByCompany,
  updateCompanySemesters,
  updateCompanyAdminData,
  updateCompanyPedagogicData,
  updateExamConcerned,
  getCompanyByGroup,
  updateCompanyCriterias,
  rejectGroupProposal,
  updateCompanyDataPonderation,
};
